import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { PatienthighriskData, PatientHighriskMst } from '../../../interfaces/masters/patient-highrisk';
import { PatientHighriskApi } from '../api/patient-highrisk.api';

@Injectable()
export class PatientHighriskService extends PatienthighriskData{

  constructor(private api: PatientHighriskApi) { 
    super();   
  }

  list(url: string): Observable<PatientHighriskMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PatientHighriskMst>{
      return this.api.getById(url); 
  }
  create(url: string, data:PatientHighriskMst): Observable<PatientHighriskMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PatientHighriskMst): Observable<PatientHighriskMst> {
    return this.api.update(url,data);
  }  
  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
